<template>
  <div class="container">

    <div class="row">
      <div class="col-md-6 text-center mx-auto">
        <h3>Faça upload do certificado da(s) sua(s) empresa(s)</h3>
        <p>O certificado digital é essencial para que a comunicação com os serviços escolhidos seja estabelecida</p>
      </div>
    </div>

    <div class="container">
      <div class="row">

        <div class="col-md-3 mx-auto" v-for="company in companies" :key="company.id">
          <UploadCertificateCompany :company="company" @saveCompany="updateCompany($event)"/>
        </div>

      </div>
    </div>

    <div class="row">

      <div class="col-md-12 text-center pt-5">
        <button @click="$emit('nextStep')" :disabled="enableNextButton"
                style="width: 370px"
                class="btn btn-primary">Concluir</button>
        <br>
        <button class="btn btn-link" @click="$emit('nextStep')" href="#">Quero fazer isso mais tarde</button>
      </div>
    </div>

  </div>

</template>

<script>
  import UploadCertificateCompany from '@/components/wizard/UploadCertificateCompany'
  import GlobalLoading from '@/mixins/GlobalLoading'

  export default {
    components: { UploadCertificateCompany },
    computed: {
      enableNextButton() {
        return !this.companies.some((company) => company.certificateExpiringAt)
      }
    },
    created() {
      const params = { q: { type: 'parent' } }
      this.openGlobalLoad()
      this.axios.get('/companies', { params: params } )
        .then((resp) => this.companies = this.$parse.toCamelcase(resp.data))
        .catch(e => this.$notify.addError(e))
        .finally(() => this.closeGlobalLoad())
    },
    data() {
      return {
        companies: []
      }
    },
    methods: {
      updateCompany(company) {
        let index = this.companies.findIndex(c => c.id === company.id)
        this.companies.splice(index, 1, company)
      }
    },
    mixins: [GlobalLoading],
    name: 'UploadCertificates'
  }
</script>

<style scoped>

</style>
